<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h1>RippleX</h1>
        <p>涟漪 · 数字员工协作服务平台</p>
      </div>
      
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="rules"
        class="login-form"
        size="medium"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            clearable
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <div class="remember-me">
            <el-checkbox v-model="loginForm.rememberMe">记住密码</el-checkbox>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            class="login-btn"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
        
        <el-form-item>
          <div class="register-link">
            还没有账号？
            <el-button type="text" @click="handleRegister">立即注册</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="login-footer">
      <p>© 2026 RippleX - 果动数智科技 版权所有</p>
    </div>
  </div>
</template>

<script>
import { login } from '../api/auth'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  created() {
    // 检查是否有记住的密码
    this.loadRememberedInfo()
  },
  methods: {
    // 加载记住的用户名密码
    loadRememberedInfo() {
      const rememberedUsername = localStorage.getItem('rememberedUsername')
      const rememberedPassword = localStorage.getItem('rememberedPassword')
      const rememberMe = localStorage.getItem('rememberMe')
      
      if (rememberMe === 'true' && rememberedUsername && rememberedPassword) {
        this.loginForm.username = rememberedUsername
        this.loginForm.password = rememberedPassword
        this.loginForm.rememberMe = true
      }
    },
    
    // 保存记住的用户名密码
    saveRememberedInfo() {
      if (this.loginForm.rememberMe) {
        localStorage.setItem('rememberedUsername', this.loginForm.username)
        localStorage.setItem('rememberedPassword', this.loginForm.password)
        localStorage.setItem('rememberMe', 'true')
      } else {
        localStorage.removeItem('rememberedUsername')
        localStorage.removeItem('rememberedPassword')
        localStorage.removeItem('rememberMe')
      }
    },
    
    // 处理登录
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        
        this.loading = true
        
        try {
          const data = await login({
            username: this.loginForm.username,
            password: this.loginForm.password
          })
          
          // 保存登录信息到Vuex
          await this.$store.dispatch('user/login', {
            userInfo: data.user,
            token: data.access_token
          })
          
          // 保存记住密码
          this.saveRememberedInfo()
          
          this.$message.success('登录成功')
          
          // 跳转到概览页
          this.$router.push({ name: 'Dashboard' })
        } catch (error) {
          console.error('登录失败:', error)
          const status = error.response?.status
          const serverMsg = error.response?.data?.message
          let msg = '登录失败，请稍后重试'

          if (status === 401) {
            msg = '用户名或密码错误，请重新输入'
          } else if (status === 403) {
            msg = '账号已被禁用，请联系管理员'
          } else if (status === 429) {
            msg = '登录尝试次数过多，请稍后再试'
          } else if (status >= 500) {
            msg = '服务器繁忙，请稍后重试'
          } else if (serverMsg) {
            msg = serverMsg
          }

          this.$notify.error({
            title: '登录失败',
            message: msg,
            duration: 4000,
            position: 'top-right'
          })
        } finally {
          this.loading = false
        }
      })
    },
    
    // 处理注册
    handleRegister() {
      this.$message.info('注册功能暂未开放，敬请期待')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;

  .login-box {
    width: 400px;
    padding: 40px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);

    .login-header {
      text-align: center;
      margin-bottom: 40px;

      h1 {
        color: #333;
        font-size: 32px;
        margin-bottom: 8px;
        font-weight: 600;
      }

      p {
        color: #666;
        font-size: 14px;
        margin: 0;
      }
    }

    .login-form {
      width: 100%;

      .login-btn {
        width: 100%;
        font-size: 16px;
        height: 44px;
      }

      .remember-me {
        width: 100%;
      }

      .register-link {
        text-align: center;
        color: #666;
        font-size: 14px;

        .el-button {
          font-size: 14px;
          padding: 0;
        }
      }
    }
  }

  .login-footer {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;

    p {
      margin: 0;
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .login-container {
    .login-box {
      width: calc(100% - 40px);
      padding: 30px 20px;
      margin: 0 20px;

      .login-header {
        h1 {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
